module.exports = __webpack_public_path__ + "img/banner-yh-pc.65082279.png";